/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "D:/WebstormProjects/hardware/mobile_v2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    return {
      caiji: require('@/assets/face/caiji.png'),
      delFlag: '',
      faceSrc: '',
      serverId: '',
      show: false,
      isFaceCheck: false,
      disabled: false,
      xiugaizhaopian: this.$route.query.xiugaizhaopian
    };
  },
  watch: {
    disabled: {
      handler: function handler(newV) {
        var _this = this;

        if (newV) {
          setTimeout(function () {
            _this.disabled = false;
          }, 1000);
        }
      },
      deep: true
    }
  },
  methods: {
    getConfig: function getConfig() {
      var _this2 = this;

      var localUrl = window.location.href.split('#')[0];
      this.$utils.Tools.getEnv(function (res) {
        if (res === 0 || res === 1) {
          _this2.$api.Sys.getConfig(localUrl, _this2.$params.mode).then(function (response) {
            var code = response.code,
                msg = response.msg,
                data = response.data;

            if (+code !== _this2.$code.success) {
              _this2.$utils.Tools.toastShow(msg);
            } else {
              _this2.$utils.WeiXin.wxConfig(data);
            }
          }).catch(function () {
            _this2.$utils.Tools.httpError();
          });
        } else {
          _this2.$api.DingTalk.getDtConfig(localUrl).then(function (response) {
            var code = response.code,
                msg = response.msg,
                data = response.data;

            if (+code !== _this2.$code.success) {
              _this2.$utils.Tools.toastShow(msg);
            } else {
              _this2.$utils.DingTalk.getConfig(data);
            }
          }).catch(function () {
            _this2.$utils.Tools.httpError();
          });
        }
      });
    },
    chooseImage: function chooseImage(Serial) {
      var _this3 = this;

      this.$utils.Tools.getEnv(function (res) {
        if (res === 0 || res === 1) {
          _this3.wxChooseImage(Serial);

          _this3.disabled = true;
        } else {
          _this3.dtChooseImage();
        }
      });
    },
    wxChooseImage: function wxChooseImage() {
      var _this4 = this;

      setTimeout(function () {
        _this4.$utils.WeiXin.wxChooseImage(function (res) {
          if (res.length > 0) {
            _this4.uploadImage(res, 0);
          }
        }, 1);
      }, 1000);
    },
    uploadImage: function uploadImage(res, i) {
      var _this5 = this;

      this.$utils.WeiXin.wxUploadImage(function (serverId) {
        //判断是否开启人脸质量验证
        _this5.disabled = false;

        if (_this5.isFaceCheck != 0) {
          var obj = {
            serverId: serverId,
            isKaiqi: true,
            show: _this5.$route.query.show,
            isFaceCheck: _this5.isFaceCheck //判断人脸照片质量检测 1：开启只检测质量；2：启用身份核验

          };

          _this5.$utils.Store.set('serverId', obj);
        } else {
          var _obj = {
            serverId: serverId,
            show: _this5.$route.query.show,
            isKaiqi: false
          };

          _this5.$utils.Store.set('serverId', _obj);
        }

        _this5.$router.go(-1);
      }, res[i]);
    },
    getValue: function getValue() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this6.$api.Attence.getKqSettting().then(function (res) {
                  _this6.isFaceCheck = res.data.faceCheck;
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  created: function created() {
    this.userSerial = this.$utils.Store.getItem('userSerial');
    this.getConfig();
    this.getValue();
  },
  mounted: function mounted() {}
};